namespace appn.views.platform.consultantClients {

    class InitArgs {
        columnCount: number = 0;
        columnWidths: number = 0;
        platformCreateConsultantClient: string = emptyString;
        platformAjaxAddExistingConsultee: string = emptyString;
    }

    let _initArgs: InitArgs;

    let _dataTable: any = null;

    export function init(args: InitArgs): void {
        _initArgs = args;
        createDataTable();
        addEvents();
    }

    function addEvents() {
        $('#addexisting').on('click', function() {
            const infoParagraph = T('To add an existing Client as one of your own clients, contact the Organization first to retrieve the information required for the fields below.<br><br>Your new client will be able to locate this information in the Integration Settings of their Organization Setup.');
            const infoParagraphElement = elementBuilder.createElement('p', undefined, undefined, undefined, infoParagraph);

            const providerIdLabel = elementBuilder.createElement('label', 'col-form-label col-md-3', undefined, [['for', 'ConsulteeProviderId']], T('Company Id'));
            const providerIdInput = elementBuilder.getSimpleInputFor('form-control form-control-sm', 'ConsulteeProviderId', 'ConsulteeProviderId', elementBuilder.HTMLInputType.Text);
            const providerIdGroup = elementBuilder.createElement('div', 'col-md-9');
            providerIdGroup.appendChild(providerIdInput);

            const providerIdFormGroup = elementBuilder.createElement('div', 'form-group row');
            providerIdFormGroup.appendChild(providerIdLabel);
            providerIdFormGroup.appendChild(providerIdGroup);

            const providerPtLabel = elementBuilder.createElement('label', 'col-form-label col-md-3', undefined, [['for', 'ConsulteePrivateToken']], T('Private Token'));
            const providerPtInput = elementBuilder.getSimpleInputFor('form-control form-control-sm', 'ConsulteePrivateToken', 'ConsulteePrivateToken', elementBuilder.HTMLInputType.Text);
            const providerPtGroup = elementBuilder.createElement('div', 'col-md-9');
            providerPtGroup.appendChild(providerPtInput);

            const providerPtFormGroup = elementBuilder.createElement('div', 'form-group row');
            providerPtFormGroup.appendChild(providerPtLabel);
            providerPtFormGroup.appendChild(providerPtGroup);

            const AddConsulteeMsg = elementBuilder.createElement('div');
            AddConsulteeMsg.appendChild(infoParagraphElement);
            AddConsulteeMsg.appendChild(providerIdFormGroup);
            AddConsulteeMsg.appendChild(providerPtFormGroup);

            appn.dialog.custom({
                modalColor: 'modal-info',
                title: T('Add Existing'),
                message: AddConsulteeMsg,
                closeButton: true,
                buttons: {
                    confirm: {
                        label: '<span>' + T('OK') + '</span>',
                        className: 'btn-success',
                        callback: function(result: boolean) {
                            if (!result)
                                return;

                            appn.ajax.post({
                                url: _initArgs.platformAjaxAddExistingConsultee,
                                data: {
                                    consulteeProviderId: $('#ConsulteeProviderId').val(),
                                    consulteePrivateToken: $('#ConsulteePrivateToken').val()
                                },
                                done: function(data: any) {
                                    const dataParsed = JSON.parse(data);


                                    if (!dataParsed.Success) {
                                        appn.toast.notify(toast.Type.error, dataParsed.Message);
                                        return;
                                    }

                                    _dataTable.fnDraw(false);
                                    appn.toast.notify(toast.Type.info, dataParsed.Message);
                                },
                                fail: function() {
                                    appn.toast.notify(toast.Type.error, T('Failed to add consultee, please check the details and try again.'));
                                }
                            });
                        }
                    }
                }
            });
        });
    }

    function createDataTable() {
        _dataTable = appn.dataTable.create('.dataTable', {
            sAjaxSource: 'ConsultantClientsDataTable',
            fnServerData: function(data: any) {
                data.push(appn.dataTable.getStateOrDefault('sCustom_0', $('#sCustom_0').prop('checked'))); // Show Archived filter
            },
            aoColumns: getDtColConfiguration(),
            fnInitComplete: function() {
                // Add in inactive checkbox in filter row

                $('#addnew').click(function(event) {
                    event.preventDefault();
                    appn.location.navTo(_initArgs.platformCreateConsultantClient);
                });

                // Add in inactive checkbox in filter row
                $('.dataTables_filter').prepend(appn.elementBuilder.buildCheckbox(appn.strings.showRetired, 'saveMeState', 'sCustom_0')).append($('.dt-action-button'));

                appn.dataTable.addSearchPlaceholder(T('Filter results where the Clients <b>Name or Status</b> contains a keyword typed in here.'));
                
                $('.dataTables_controls_start').append($('.dt-action-title'));

                appn.saveMeState.init(function() {
                    _dataTable.fnDraw(false);
                },
                    function() {
                        _dataTable.fnDraw(false);
                    }, '.dataTables_filter');
            },
            fnDrawCallback: function() {
                $('.viewUserAudit').off().on('click', function (this: HTMLElement, event: Event) {
                    event.preventDefault();

                    const auditUrl = $(this).attr('href') as string;
                    appn.iframe.openModal({ url: auditUrl });
                });
            }
        });
    }

    function getDtColConfiguration(): Array<IDTColumns> {
        const aoColumns: Array<IDTColumns> = [];

        aoColumns.push({ bSortable: true, sWidth: '25%' } as IDTColumns,
            { bSortable: true, sWidth: '10%' } as IDTColumns);

        for (let i = 2; i < _initArgs.columnCount; i++)
            aoColumns.push({ bSortable: true, sWidth: `${_initArgs.columnWidths}%` } as IDTColumns);

        aoColumns.push({ bSortable: true, sWidth: '15%' } as IDTColumns,
            { bSortable: true, sWidth: '15%' } as IDTColumns);

        return aoColumns;
    }
}
